import { motion } from "framer-motion";
import { IMAGES, INDUSTRIES } from "@/site/content";

// Tetris-style bento grid
const tiles = [
  { label: "Plumbers", img: IMAGES.industry_plumber, span: "md:col-span-2 md:row-span-2 h-[420px]" },
  { label: "Restaurants", img: IMAGES.industry_restaurant, span: "h-[200px]" },
  { label: "Landscapers", img: IMAGES.industry_landscaper, span: "h-[200px]" },
  { label: "Electricians", img: IMAGES.industry_electrician, span: "md:col-span-2 h-[200px]" },
  { label: "Retail Stores", img: IMAGES.industry_retail, span: "h-[200px]" },
  { label: "HVAC", img: IMAGES.industry_hvac, span: "h-[200px]" },
  { label: "Painters", img: IMAGES.industry_painter, span: "h-[200px]" },
  { label: "Auto Repair", img: IMAGES.industry_auto, span: "h-[200px]" },
];

export const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
              Who we work with
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
              Built specifically for the people who built your town.
            </h2>
          </div>
          <p className="lg:col-span-5 text-gray-600 text-base leading-relaxed">
            From the plumber down the street to the family restaurant on the
            corner — we speak small business, not Silicon Valley.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {tiles.map((t, i) => (
            <motion.div
              key={t.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className={`relative rounded-xl overflow-hidden border border-gray-200 group ${t.span}`}
              data-testid={`industry-tile-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <img
                src={t.img}
                alt={t.label}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/85 via-gray-900/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="font-display font-bold text-white text-lg md:text-xl">
                  {t.label}
                </div>
                <div className="text-xs text-gray-300 mt-1">
                  Custom site built around your craft
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-2">
          {INDUSTRIES.map((ind) => (
            <span
              key={ind.key}
              className="inline-flex items-center px-3 py-1.5 rounded-full border border-gray-200 bg-gray-50 text-xs text-gray-700"
              data-testid={`industry-pill-${ind.key}`}
            >
              {ind.label}
            </span>
          ))}
          <span className="inline-flex items-center px-3 py-1.5 rounded-full border border-blue-200 bg-blue-50 text-xs text-blue-700 font-medium">
            + your trade
          </span>
        </div>
      </div>
    </section>
  );
};
